// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui';
Vue.use(Mint)
import plugins from './plugins/plugins'
Vue.use(plugins)

Vue.config.productionTip = true
router.beforeEach((to, from, next) => {
  document.title = to.meta.title; //改变标题
  if(to.path == '/shopcard/info'){
    if(to.query.type == 'discount'){
      document.title = '折扣卡'
    }else{
      document.title = '计次卡'
    }
  }
	window.scroll(0, 0);
	if(to.fullPath.indexOf('token') >= 0) {
	   var logindata = {
				token: to.query.token,
				time: to.query.expiresIn,
				type: to.query.type
      }
	   localStorage.authtoken = JSON.stringify(logindata);
	   try{
	   	if(typeof to.query.token == "object") {
        var logindata = {
          token: to.query.token[1],
          time: to.query.expiresIn,
          type: to.query.type
        }
			  localStorage.authtoken = JSON.stringify(logindata);
      } else {
        var logindata = {
          token: to.query.token,
          time: to.query.expiresIn,
          type: to.query.type
        }
        localStorage.authtoken = JSON.stringify(logindata);
      }
	  }
    catch(error) {
  　　   var logindata = {
        token: to.query.token,
        time: to.query.expiresIn,
        type: to.query.type
      }
      localStorage.authtoken = JSON.stringify(logindata);
  　}
    next(funcUrlDel("token"));
	}
	var data = localStorage.getItem('authtoken');
	var token = '';

	if(data != undefined || data != null) {

    var dataObj = JSON.parse(data);

		if(new Date().getTime() > dataObj.time) {
			localStorage.clear();
		} else {
			token = dataObj.token;
		}
	} else {
		if(to.query.shopAlias != undefined && to.query.shopAlias != 'undefined') {
			if(localStorage.shopAlias == to.query.shopAlias) {

			} else {
				localStorage.shopAlias = to.query.shopAlias;
			}
		}
	}
	if(token.length == 0 && to.path != '/user/login') {
		if((to.path).indexOf('/home') >= 0 || (to.path).indexOf('/gamble') >= 0 || (to.path).indexOf('/shop') >= 0 ||(to.path).indexOf('/map') >= 0 ||(to.path).indexOf('/ticket') >= 0 || to.path =='/cell'  ||(to.path).indexOf('membercard') >= 0 || (to.path).indexOf('/qcode') >= 0 || (to.path).indexOf('/app') >= 0 || (to.path).indexOf('/wap') >= 0 || (to.path).indexOf('/cashier') >= 0 || (to.path).indexOf('/index') >= 0 || (to.path).indexOf('/apptransfer') >= 0 || (to.path).indexOf('/shopcard/info') >= 0 || (to.path).indexOf('/help') >= 0 || (to.path).indexOf('/cell/goodssearch') >= 0 || (to.path).indexOf('/cell/goodssearchlist') >= 0 || (to.path).indexOf('/cell/goodsdetail') >= 0  || (to.path).indexOf('/gift/detail') >= 0 ) {
			next();
		} else {
			localStorage.lasturl = window.location.protocol+'//'+ window.location.host + from.fullPath;
			next('/user/login?shopAlias=' + localStorage.shopAlias);
		}
	} else {
    localStorage.lasturl = window.location.protocol+'//'+ window.location.host + from.fullPath;
		next();
	}
})
function funcUrlDel(name){
    var loca = window.location;
    var baseUrl =  loca.pathname + "?";
    var query = loca.search.substr(1);
    if (query.indexOf(name)>-1) {
        var obj = {}
        var arr = query.split("&");
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split("=");
            obj[arr[i][0]] = arr[i][1];
        };
        delete obj[name];
        var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");
        return url
    };
}
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	template: '<App/>',
	components: {
		App
	}
})



// WEBPACK FOOTER //
// ./src/main.js